import { ApiRequestError } from '@/lib/api/client';
import { runtimeConfig } from '@/lib/config';

/**
 * 개인 설정을 localStorage 로 물러서도 되는 상황인지.
 *
 * "닿지 못함" 은 두 모습으로 온다 — 직접 호출(cross-origin)은 fetch 가 TypeError 로 거부하고,
 * Vite 프록시는 대상이 죽으면 <b>봉투 없는</b> 5xx 를 돌려준다. 살아 있는 백엔드는 5xx 라도 항상
 * JSON 봉투를 실어 보내므로 apiError 가 있다 — 그건 진짜 장애이니 덮지 않는다.
 * ({@code lib/auth/session.ts} 의 목 세션 판정과 같은 규칙이다.)
 *
 * <b>운영에서는 절대 물러서지 않는다.</b> `mockSessionWhenOffline` 은 개발 빌드에서만 켜진다.
 */
export function canFallBackOffline(error: unknown): boolean {
  const unreachable =
    error instanceof TypeError || (error instanceof ApiRequestError && error.apiError === null);
  return unreachable && runtimeConfig().mockSessionWhenOffline;
}
